var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maxHr)?_c('span',{staticClass:"text-small ml-1 label-hr-max"},[_vm._v(_vm._s(_vm.$t('sessionsInfo.heartRate'))),_c('sub',[_vm._v("max")]),_vm._v(" = "+_vm._s(_vm.maxHr)+" "+_vm._s(_vm.$t('unit.bpm')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }